import * as XLSX from 'xlsx';

export function exportMLMUserMonthlyPerformanceExcel(data, fileName = 'mlm-user-monthly-performance.xlsx') {
    // Map data to columns (same as the table columns)
    const columns = [
        { header: 'Consulton Id', key: 'mlmuserid' },
        { header: 'First Name', key: 'mlmfirstname' },
        { header: 'Second Name', key: 'mlmsecondname' },
        { header: 'Sponsor ID', key: 'sponsorid' },
        { header: 'Self Point', key: 'mlmselfponit' },
        { header: 'Group Point', key: 'mlmgroupponit' },
        { header: 'Self BV', key: 'mlmselfbv' },
        { header: 'Group BV', key: 'mlmgroupbv' },
        { header: 'Self Per Discount', key: 'mlmselfperdiscount' },
        { header: 'Group Earn', key: 'mlmgroupperamount' },
        { header: 'Self Earn', key: 'mlmselfperamount' },
        { header: 'Month Total Earn', key: 'mlmmonthtotalearn' },
    ];

    // Prepare worksheet data
    const worksheetData = [columns.map(col => col.header)];
    data.forEach(row => {
        worksheetData.push(columns.map(col => row[col.key]));
    });

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'MLMUserMonthlyPerformance');

    // Export to file
    XLSX.writeFile(workbook, fileName);
}
